import React, { useEffect, useState } from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import CusInput from '../../../components/material-ui/CusInput';
import { Stack } from '@mui/material';
import CusButton from '../../../components/material-ui/CusButton';
import { useTranslation } from 'react-i18next';
import { API_USERS } from '../../../api/users';
import useToast from '../../../hooks/useToast';

export default function ChangeCommentModal({ open, closeModal, user = {}, setSelectUserFull }) {
  const { t } = useTranslation();
  const { successToast } = useToast();
  const userComment = user.comment;
  const [comment, setComment] = useState(userComment);

  const title = `${t('Edit user comment')} ${user?.login}`;

  const onSaveClick = () => {
    API_USERS.info
      .update({ userId: user.userId, comment })
      .then((e) => {
        setSelectUserFull((prev) => ({ ...prev, comment: comment }));
        successToast('The comment has been successfully updated');
        closeModal();
      })
      .catch(console.error);
  };

  useEffect(() => {
    if (!open) return;
    setComment(userComment);
  }, [open, userComment]);

  return (
    <InfoDialog
      open={open}
      onClose={closeModal}
      title={title}
      maxWidth="xs"
      onSaveClick={onSaveClick}>
      <Stack direction={'column'} gap={2}>
        <CusInput
          autoFocus={open}
          rows={3}
          label={'Comment'}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
      </Stack>
    </InfoDialog>
  );
}
